import React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { PageWithBlocks, PageWithBlocksState } from '../cmsPageState'
import { PreviewHeaderLayout } from '../pages/utils'

export const previewWidget = (page: PageWithBlocks): Widget<Updater<PageWithBlocksState>> => {
  return fromJSX(() => <PreviewHeaderLayout slug={page.path} />)
}
